/* Native details remain usable if JavaScript is unavailable. */
(() => {
 const header = document.querySelector('[data-kh-header]');
 if (!header) return;
 const menus = [...header.querySelectorAll('[data-kh-menu]')];
 const close = () => header.querySelectorAll('details[open]').forEach(d => { d.open = false; });
 menus.forEach(menu => {
  menu.addEventListener('toggle', () => {
   if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
  });
 });
 const account = header.querySelector('.kh-account');
 if (account) {
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  let closeTimer;
  account.addEventListener('pointerenter', event => {
   if (event.pointerType !== 'mouse' || !hover.matches) return;
   window.clearTimeout(closeTimer);
   account.open = true;
  });
  account.addEventListener('pointerleave', event => {
   if (event.pointerType !== 'mouse') return;
   closeTimer = window.setTimeout(() => {
    if (!account.matches(':focus-within')) account.open = false;
   }, 180);
  });
  account.addEventListener('focusout', event => {
   if (!account.contains(event.relatedTarget)) {
    window.clearTimeout(closeTimer);
    account.open = false;
   }
  });
 }
 document.addEventListener('pointerdown', event => { if (!header.contains(event.target)) close(); });
 header.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
   const active = event.target.closest('details[open]');
   close();
   active?.querySelector('summary')?.focus();
  }
 });
})();